exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project.complete{border-left:4px solid #039be5}.project.ongoing{border-left:4px solid #ffa600}.project.overdue{border-left:4px solid tomato}", ""]);

// exports
